import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/Modal/Modal";
import {
  addStudent,
  deleteStudent,
  fetchSessionsV2,
  fetchSummary,
  selectStudent,
} from "../../redux/actions";
import "./styles.css";
import StudentsList from "../../components/StudentsList/StudentsList";
import StudentSummary from "../../components/StudentSummary/StudentSummary";
import Locale from "../../locales";
import { showStudentReport } from "../../redux/actions/teacher";

const initNewStudent = { emailId: "", name: "" };
const Dashboard = () => {
  const dispatch = useDispatch();
  const students = useSelector((state) => state.teacherReducer.students);
  const currentUser = useSelector((state) => state.authReducer.currentUser);
  const loading = useSelector((state) => state.teacherReducer.loading);
  const [open, setOpen] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteEmail, setDeleteEmail] = useState(null);
  const history = useHistory();
  const [newStudent, setNewStudent] = useState(initNewStudent);
  const summaryStudent = useSelector(
    (state) => state.teacherReducer.currentStudent,
  );
  const addNewClicked = () => {
    setModalVisible(!modalVisible);
  };

  const closeModalClicked = () => {
    setModalVisible(false);
  };

  const userAdded = () => {
    dispatch(addStudent(newStudent, currentUser));
    setModalVisible(false);
    setNewStudent(initNewStudent);
  };

  const deleteUser = (studentId) => {
    dispatch(deleteStudent(studentId));
  };

  const clearStudent = () => {
    dispatch(selectStudent(null));
    dispatch(showStudentReport(null, ""));
  };

  const confirmedDelete = () => {
    deleteUser(deleteEmail);
    setOpen(false);
    clearStudent();
  };

  const deleteHandler = (studentId) => {
    setOpen(true);
    setDeleteEmail(studentId);
  };

  const handleClose = () => {
    setOpen(false);
    setDeleteEmail(null);
  };

  const studentClicked = (studentId, studentName) => {
    const data = {
      studentId,
      queryStartDateTimeUTC: new Date(
        Date.now() - 7 * 24 * 60 * 60 * 1000,
      ).toISOString(),
      queryEndDateTimeUTC: new Date(Date.now()).toISOString(),
    };
    dispatch(fetchSummary(data));
    dispatch(showStudentReport(studentId, studentName));
  };

  const goToProfilehandler = () => {
    dispatch(selectStudent(summaryStudent));
    history.push("/tasks");
    // const payload = {
    //   studentId: summaryStudent,
    //   queryStartDateTimeUTC: new Date(
    //     Date.now() - 7 * 24 * 60 * 60 * 1000,
    //   ).toISOString(),
    //   queryEndDateTimeUTC: new Date(Date.now()).toISOString(),
    // };
    dispatch(fetchSessionsV2(summaryStudent));
    // dispatch(getStudentPerformance(payload));
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle>{Locale.t("confirm_delete")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {Locale.t("are_you_sure_you_want_to_delete_this_user")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{Locale.t("no")}</Button>
          <Button onClick={confirmedDelete} color="error">
            {Locale.t("delete")}
          </Button>
        </DialogActions>
      </Dialog>
      <div className="teacher-dashboard-page">
        <StudentSummary />
        {modalVisible && (
          <Modal
            onAddUser={userAdded}
            newStudent={newStudent}
            setNewStudent={setNewStudent}
            closeModal={closeModalClicked}
            editMode={false}
            modalVisible={modalVisible}
          />
        )}
        <div>
          <div className="proceed-to-profile-button-container">
            {!loading && (
              <Button onClick={clearStudent} size="small" variant="text">
                {Locale.t("class_average_performance")}
              </Button>
            )}
            {summaryStudent && !loading && (
              <Button
                onClick={goToProfilehandler}
                endIcon={<DoubleArrowIcon />}
                size="small"
                variant="contained">
                {Locale.t("proceed_to_profile")}
              </Button>
            )}
          </div>
          <StudentsList
            studentClicked={studentClicked}
            addNewClicked={addNewClicked}
            students={students}
            deleteHandler={deleteHandler}
          />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
